import { t } from 'ttag';
import classNames from 'classnames';

import { Button } from '@ui/Button';
import { SavedSearchSubscribeldContainer } from '@containers/SavedSearchSubscribeld';
import TelegramIcon from '@svg/telegram-light.svg';

// styles
import s from './SavedSearchSubscribeldTop.sss';

type SavedSearchSubscribeldTopType = {
  onTelegramClick(): void;
  filter?: string;
  productId?: string | null;
  className?: string;
};

export const SavedSearchSubscribeldTop: React.FC<SavedSearchSubscribeldTopType> = ({
  onTelegramClick,
  filter,
  productId,
  className,
}) => (
  <div className={classNames(s.root, className, { [s.filter]: filter })}>
    <p className={s.title}>
      {t`Підписатися на пошук`}
    </p>
    <SavedSearchSubscribeldContainer isSavedSearchTop={true} productId={productId} />
    <Button
      theme="secondary"
      onClick={() => {
        onTelegramClick();
      }}
      className={s.button}
    >
      <TelegramIcon className={s.telegramIcon} />
      <p className={s.text}>В Telegram</p>
    </Button>
  </div>
);

export default SavedSearchSubscribeldTop;
